<template>
  <div class="flex-col gap-y-md">
    <dd-header-card header="Algemene instellingen">
      <GeneralSettings/>
    </dd-header-card>
    <ChooseAutomationActions></ChooseAutomationActions>
  </div>
</template>

<script>
import GeneralSettings from "../GeneralSettings.vue";
import ChooseAutomationActions from "../ChooseAutomationActions.vue";

export default {
  name: "SelectionSettingsStep",
  components: {
    GeneralSettings,
    ChooseAutomationActions
  }
};
</script>

<style scoped>

</style>
